import { service } from '../axios';
// export function onSave(data: any): Promise<any> {
// 	return service({url: '/userRole/save',method: 'post',data})
// }
export function saveRolePermission(data) {
    return service({ url: '/userRole/saveRolePermissions', method: 'post', data });
}
export function saveViewPermissions(data) {
    return service({ url: '/userRole/saveViewPermissions', method: 'post', data });
}
export function saveUserRoles(params) {
    return service({
        url: '/userRole/saveUserRoles',
        method: 'post',
        data: params
    });
}
export function getUserRoles(uid) {
    return service({
        url: '/userRole/getUserRoles',
        method: 'get',
        params: { uid }
    });
}
export function getUserListByRoleId(params) {
    return service({ url: '/userRole/getUserListByRoleId', method: 'get', params });
}
export function addUserRole(params) {
    return service({
        url: '/userRole/add',
        method: 'post',
        params
    });
}
/** 单个用户移除单个角色 */
export function removeUserRole(params) {
    return service({
        url: '/userRole/remove',
        method: 'delete',
        params
    });
}
